(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("iO6mJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f93b2727744a1dda$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $awtH3 = parcelRequire("awtH3");
var $54mKn = parcelRequire("54mKn");

var $4Xjp8 = parcelRequire("4Xjp8");
const $f93b2727744a1dda$var$basename = "/till-salu/";
const $f93b2727744a1dda$var$ForSaleComponent = ({ stickyTitle: stickyTitle, stickyText: stickyText })=>{
    const path = `/:estateType?/:county?/:muni?/:area?`;
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $awtH3.BrowserRouter), {
        basename: $f93b2727744a1dda$var$basename,
        children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $54mKn.Routes), {
            children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $54mKn.Route), {
                path: path,
                element: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "relative",
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $4Xjp8.ForSaleComponentInner), {
                        stickyTitle: stickyTitle,
                        stickyText: stickyText
                    })
                })
            })
        })
    });
};
var $f93b2727744a1dda$export$2e2bcd8739ae039 = $f93b2727744a1dda$var$ForSaleComponent;

});
parcelRegister("4Xjp8", function(module, exports) {

$parcel$export(module.exports, "ForSaleComponentInner", function () { return $b13d38dcc4f5cbf0$export$5783d03d8957aabb; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $a1uyt = parcelRequire("a1uyt");

var $22cn8 = parcelRequire("22cn8");

var $54mKn = parcelRequire("54mKn");

var $l8eky = parcelRequire("l8eky");

var $jfnuU = parcelRequire("jfnuU");

var $1A7pc = parcelRequire("1A7pc");

var $60LpM = parcelRequire("60LpM");

var $67EyS = parcelRequire("67EyS");

var $cUbQm = parcelRequire("cUbQm");

var $1QzIr = parcelRequire("1QzIr");

var $5jxwZ = parcelRequire("5jxwZ");

var $lcDRl = parcelRequire("lcDRl");

var $i7TBI = parcelRequire("i7TBI");

const $b13d38dcc4f5cbf0$var$FilterEstatesComponent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("34thG")));

const $b13d38dcc4f5cbf0$var$SEOHeadingComponent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("2wZwx")));

const $b13d38dcc4f5cbf0$var$ObjectListComponent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("iYbNK")));

const $b13d38dcc4f5cbf0$var$MonitorSearchFormForSalePage = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("cCGyt")));
const $b13d38dcc4f5cbf0$var$basename = "/till-salu/";
const $b13d38dcc4f5cbf0$export$5783d03d8957aabb = ({ stickyTitle: stickyTitle, stickyText: stickyText })=>{
    const [tags, setTags] = (0, $dTCkE.useState)([]);
    const [visibleExtraCrits, setVisibleExtraCrits] = (0, $dTCkE.useState)({});
    const [isAuthorizedBroker, setIsAuthorizedBroker] = (0, $dTCkE.useState)(false);
    const [showErrorForSale, setShowErrorForSale] = (0, $dTCkE.useState)(false);
    const [badFarmCombo, setBadFarmCombo] = (0, $dTCkE.useState)(false);
    const [missingSearchParams, setMissingSearchParams] = (0, $dTCkE.useState)(false);
    const [forbiddenEstateType, setForbiddenEstateType] = (0, $dTCkE.useState)(false);
    const scrollLockUntilTagChange = (0, $dTCkE.useRef)(false);
    const filterItemClicked = (0, $dTCkE.useRef)(false);
    const path = (0, $54mKn.useParams)();
    const sessionId = (0, $l8eky.getSessionId)();
    const { data: user } = (0, $jfnuU.default)(sessionId);
    const isBigScreen = (0, $67EyS.default)("(min-width: 64rem)");
    const isMediumScreen = (0, $67EyS.default)("(min-width: 46rem)");
    const isSmallScreen = (0, $67EyS.default)("(max-width: 55.9rem)");
    const [showHideModal, setShowHideModal] = (0, $dTCkE.useState)(false);
    const [objectListLayout, setObjectListLayout] = (0, $dTCkE.useState)("row");
    const [showMapFilter, setShowMapFilter] = (0, $dTCkE.useState)(false);
    const menuHeight = (0, $i7TBI.default)();
    const topMargin = menuHeight > 50 ? "top-[56px]" : "top-[48px]";
    const heightForMobileMapContainer = menuHeight > 50 ? "h-[calc(100dvh-56px)]" : "h-[calc(100dvh-48px)]";
    const scrollRef = (0, $dTCkE.useRef)(null);
    (0, $dTCkE.useEffect)(()=>{
        var loginType = (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).get("loginType");
        setIsAuthorizedBroker(loginType === "2");
    }, []);
    (0, $dTCkE.useEffect)(()=>{
        const handleScroll = ()=>{
            if (!scrollRef.current) return;
            const rect = scrollRef.current.getBoundingClientRect();
            if (rect.top <= -200 && objectListLayout === "map" && isBigScreen) setShowHideModal(false);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        showHideModal
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (showMapFilter && !isBigScreen || showHideModal && !isBigScreen) document.documentElement.style.overflow = "hidden";
        else document.documentElement.style.overflow = "";
        return ()=>{
            document.documentElement.style.overflow = "";
        };
    }, [
        showMapFilter,
        isBigScreen,
        showHideModal
    ]);
    //on filter change
    (0, $dTCkE.useEffect)(()=>{
        if (!filterItemClicked.current) return;
        scrollLockUntilTagChange.current = false;
        const searchFilter = (0, $22cn8.filterToQuerystring)(tags);
        // update url in browser
        const currentUrl = window.location.href;
        let viewSetting = "";
        if (currentUrl.indexOf((0, $cUbQm.ObjectListLayout).Map) > -1 || currentUrl.indexOf((0, $cUbQm.ObjectListLayout).Row) > -1) {
            if (currentUrl.indexOf((0, $cUbQm.ObjectListLayout).Map) > -1) viewSetting = "#" + (0, $cUbQm.ObjectListLayout).Map;
            else viewSetting = "#" + (0, $cUbQm.ObjectListLayout).Row;
        }
        window.history.replaceState(null, "", $b13d38dcc4f5cbf0$var$basename + searchFilter + viewSetting);
        if (tags.length === 0) setTags([
            {
                type: (0, $cUbQm.FilterTypes).AllEstates,
                isChecked: true,
                label: "Alla bost\xe4der"
            }
        ]);
        else {
            var existingTags = tags.find((x)=>x.isChecked === true);
            var allEstates = tags.find((x)=>x.type === (0, $cUbQm.FilterTypes).AllEstates);
            if (!existingTags || existingTags === undefined) {
                if (allEstates === undefined) setTags([
                    ...tags,
                    {
                        type: (0, $cUbQm.FilterTypes).AllEstates,
                        isChecked: true,
                        label: "Alla bost\xe4der"
                    }
                ]);
                else setTags(tags.map((x)=>{
                    if (x.type === (0, $cUbQm.FilterTypes).AllEstates) x.isChecked = true;
                    return x;
                }));
            } else setTags(tags);
        }
    }, [
        tags
    ]);
    (0, $dTCkE.useEffect)(()=>{
        function callback(tags) {
            setTimeout(()=>{
                setTags(tags);
            }, 100);
        }
        if (path.estateType) (0, $22cn8.getFilterFromPath)(path).then(callback);
        else (0, $22cn8.getFilterFromQueryParams)().then(callback);
    }, []);
    if (isSmallScreen === undefined && isMediumScreen === undefined && isBigScreen === undefined) return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "top-0 left-0 z-[1003] absolute bg-white w-full h-full"
    });
    const handleShowLayout = (layout)=>{
        setObjectListLayout(layout);
        setShowMapFilter(false);
        var url = window.location.href.split("#")[0];
        const newUrl = url + "#" + layout;
        window.location.href = newUrl;
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a1uyt.ForSaleBrokerContext).Provider, {
        value: {
            isAuthorizedBroker: isAuthorizedBroker,
            showErrorForSale: showErrorForSale,
            setShowErrorForSale: setShowErrorForSale,
            setIsAuthorizedBroker: setIsAuthorizedBroker
        },
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $22cn8.FilterContext).Provider, {
            value: {
                isSmallScreen: isSmallScreen,
                isBigScreen: isBigScreen,
                isMediumScreen: isMediumScreen,
                tags: tags,
                setTags: (newTags)=>{
                    filterItemClicked.current = true;
                    setTags(newTags);
                },
                visibleExtraCrits: visibleExtraCrits,
                setVisibleExtraCrits: (newTags)=>{
                    filterItemClicked.current = true;
                    setVisibleExtraCrits(newTags);
                },
                sessionId: sessionId,
                user: user
            },
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($b13d38dcc4f5cbf0$var$SEOHeadingComponent, {
                        path: path
                    })
                }),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    ref: scrollRef,
                    className: "lg:flex lg:justify-between mx-auto max-w-10xl",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: `lg:w-1/4 w-full lg:min-w-[25.8rem] ${objectListLayout == "map" && !isBigScreen ? `${topMargin} ${showMapFilter ? "right-0 overflow-auto" : "-right-[100vw]"} z-[1003] fixed ${heightForMobileMapContainer} w-[100vw]` : ""}`,
                            children: [
                                !isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $1QzIr.default), {
                                    stickyField: true,
                                    inputLabel: (0, $cUbQm.Estates).SearchPlaceholder,
                                    activeInput: false,
                                    countySelected: false,
                                    multipleEstateTypesSelected: false,
                                    brokerOrOfficeTypesSelected: false,
                                    commercialOrProject: false,
                                    showMapFilter: showMapFilter
                                }),
                                objectListLayout !== "map" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    className: "lg:hidden flex justify-center pt-3 pb-2",
                                    children: /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                        onClick: ()=>handleShowLayout("map"),
                                        className: "flex gap-2 text-blue700",
                                        children: [
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                className: "whitespace-nowrap",
                                                children: "S\xf6k p\xe5 karta"
                                            }),
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                src: "/Images/Icons/map-pin-line-blue.svg",
                                                alt: "S\xf6k p\xe5 karta"
                                            })
                                        ]
                                    })
                                }),
                                objectListLayout === "map" && !isBigScreen && showMapFilter && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                    className: "bottom-0 left-0 z-[1005] fixed flex justify-center gap-6 bg-white py-2 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                            onClick: ()=>{
                                                handleShowLayout("row");
                                                setTimeout(()=>{
                                                    const element = document.querySelector("#object-content-view");
                                                    if (element && isSmallScreen) element.scrollIntoView({
                                                        behavior: "smooth",
                                                        block: "start"
                                                    });
                                                }, 40);
                                            },
                                            className: "flex justify-center items-center gap-3 bg-blue700 py-2 rounded-3xl w-full max-w-micro text-white",
                                            children: [
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                    children: "Lista"
                                                }),
                                                /*#__PURE__*/ (0, $a9eYm.jsxs)("svg", {
                                                    width: "19",
                                                    height: "19",
                                                    viewBox: "0 0 19 19",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "w-[14px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $a9eYm.jsx)("rect", {
                                                            width: "19",
                                                            height: "8",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $a9eYm.jsx)("rect", {
                                                            y: "11",
                                                            width: "19",
                                                            height: "8",
                                                            fill: "white"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                            className: "flex justify-center items-center gap-3 bg-blue700 py-2 rounded-3xl w-full max-w-micro text-white",
                                            onClick: ()=>setShowMapFilter(false),
                                            children: [
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                    children: "Karta"
                                                }),
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                    className: "w-5 h-auto -translate-y-[1px]",
                                                    src: "/Images/Icons/map-pin-line-white.svg",
                                                    alt: "Visa karta"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $dTCkE.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $60LpM.SearchFieldFallback), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $a9eYm.jsx)($b13d38dcc4f5cbf0$var$FilterEstatesComponent, {
                                            setShowHideModal: setShowHideModal,
                                            objectListLayout: objectListLayout,
                                            handleShowLayout: (layout)=>handleShowLayout(layout)
                                        }),
                                        objectListLayout !== "map" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                            className: "lg:hidden flex justify-center pb-5",
                                            children: /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                                onClick: ()=>setShowHideModal(true),
                                                className: "flex justify-center items-center gap-2 bg-blue700 py-3 rounded-3xl w-full max-w-xxs text-white",
                                                children: [
                                                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                        children: "Skapa bevakning"
                                                    }),
                                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                        className: "w-6 h-auto",
                                                        src: "/Images/Icons/monitoring_white.svg",
                                                        alt: "Skapa bevakning"
                                                    })
                                                ]
                                            })
                                        }),
                                        !isBigScreen && objectListLayout !== "map" && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lcDRl.default), {
                                            sessionId: sessionId,
                                            setShowHideModalFunction: setShowHideModal
                                        })
                                    ]
                                }),
                                showHideModal && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    className: `${topMargin} lg:top-[64px] left-0 z-[1000] fixed w-full pointer-events-none`,
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                        className: `relative mx-auto max-w-10xl ${heightForMobileMapContainer} lg:h-[calc(100dvh-64px)]`,
                                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                            className: "top-0 left-0 lg:left-[25.8rem] xxl2:left-[25%] absolute bg-white shadow-[100px_0_80px_rgba(0,0,0,0.3)] border-l-1 border-l-grey100 w-full lg:w-[411px] h-full overflow-x-hidden pointer-events-auto",
                                            children: [
                                                /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                                    title: "St\xe4ng",
                                                    className: "top-4 right-2 z-40 absolute flex items-center self-center bg-white px-2 py-1 rounded-full focus:outline-none text-blue700 lg:hover:underline transition-all button",
                                                    type: "button",
                                                    onClick: ()=>{
                                                        setShowHideModal(false);
                                                    },
                                                    children: [
                                                        "St\xe4ng",
                                                        /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                            className: "ml-2 w-5 h-auto rotate-180 transform",
                                                            src: "/Images/Icons/close.svg",
                                                            alt: "st\xe4ng ikon"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                    className: "max-h-[100%] overflow-x-hidden overflow-y-auto",
                                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($b13d38dcc4f5cbf0$var$MonitorSearchFormForSalePage, {
                                                            setShowHideModalFunction: setShowHideModal,
                                                            open: showHideModal,
                                                            hasAllReqParamsToSave: missingSearchParams,
                                                            forBiddenEstateTypes: forbiddenEstateType,
                                                            badFarmCombo: badFarmCombo
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)($b13d38dcc4f5cbf0$var$ObjectListComponent, {
                            stickyTitle: stickyTitle,
                            stickyText: stickyText,
                            badFarmCombo: badFarmCombo,
                            setBadFarmCombo: setBadFarmCombo,
                            missingSearchParams: missingSearchParams,
                            setMissingSearchParams: setMissingSearchParams,
                            setForbiddenEstateType: setForbiddenEstateType,
                            forbiddenEstateType: forbiddenEstateType,
                            setObjectListLayout: setObjectListLayout,
                            objectListLayout: objectListLayout,
                            setShowMapFilter: setShowMapFilter,
                            setShowHideModal: setShowHideModal
                        }),
                        showHideModal && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                                    children: `
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'filter_klick',
                    eventInfo: {
                      buttonText: 'Bevaka s\xf6kning'
                    }
                  });
                `
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $b13d38dcc4f5cbf0$export$2e2bcd8739ae039 = $b13d38dcc4f5cbf0$export$5783d03d8957aabb;

});
parcelRegister("a1uyt", function(module, exports) {

$parcel$export(module.exports, "ForSaleBrokerContext", function () { return $4b20ca3b8bdd5e3d$export$c4754ec34da4974d; });

var $a9eYm = parcelRequire("a9eYm");

var $1A7pc = parcelRequire("1A7pc");

var $dTCkE = parcelRequire("dTCkE");
const $4b20ca3b8bdd5e3d$export$c4754ec34da4974d = /*#__PURE__*/ (0, $dTCkE.createContext)({});
const $4b20ca3b8bdd5e3d$var$ForSaleBrokerContextProvider = ({ children: children })=>{
    const [isAuthorizedBroker, setIsAuthorizedBroker] = (0, $dTCkE.useState)(false);
    const [showErrorForSale, setShowErrorForSale] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        var loginType = (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).get("loginType");
        setIsAuthorizedBroker(loginType === "2");
    }, []);
    const contextObject = {
        isAuthorizedBroker: isAuthorizedBroker,
        showErrorForSale: showErrorForSale,
        setShowErrorForSale: setShowErrorForSale,
        setIsAuthorizedBroker: setIsAuthorizedBroker
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)($4b20ca3b8bdd5e3d$export$c4754ec34da4974d.Provider, {
        value: contextObject,
        children: children
    });
};
var $4b20ca3b8bdd5e3d$export$2e2bcd8739ae039 = $4b20ca3b8bdd5e3d$var$ForSaleBrokerContextProvider;

});
parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});


parcelRegister("jfnuU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b90f5fe43eab46e$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $6b90f5fe43eab46e$var$useUserContactId = (sessionId)=>{
    return (0, $4cyLg.useQuery)([
        "sessionId",
        sessionId
    ], ()=>(0, $1HGFx.UserService).userGetContactId(sessionId).then((response)=>response), {
        enabled: !!sessionId
    });
};
var $6b90f5fe43eab46e$export$2e2bcd8739ae039 = $6b90f5fe43eab46e$var$useUserContactId;

});

parcelRegister("60LpM", function(module, exports) {

$parcel$export(module.exports, "SearchFieldFallback", function () { return $f3b70b6a0c62ea8f$export$8a6fc59e3803f1c2; });

var $a9eYm = parcelRequire("a9eYm");

var $cUbQm = parcelRequire("cUbQm");

var $bGu79 = parcelRequire("bGu79");
const $f3b70b6a0c62ea8f$export$8a6fc59e3803f1c2 = ()=>{
    const filteredEstateTypes = Object.values((0, $cUbQm.EstateType)).filter((type)=>type !== (0, $cUbQm.EstateType).OwnedApartment && type !== (0, $cUbQm.EstateType).Premises);
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "top-0 lg:top-[4rem] left-0 lg:sticky bg-white pt-3 lg:w-1/4 lg:min-w-[25.8rem] max-w-[25.8rem] h-full lg:max-h-[100vh] lg:overflow-y-auto no-scrollbar",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "animate-pulse",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "z-[10] bg-grey50 mr-3 pl-2 rounded-r-3xl h-12 lg:h-16"
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "justify-items-stretch gap-2 md:gap-3 grid grid-cols-4 md:grid-cols-7 lg:grid-cols-4 mt-4 mdplus:mb-4 px-3 overflow-hidden",
                    children: filteredEstateTypes?.map((type)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $bGu79.EstateSelectorFallback), {}, type))
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "bg-grey50 mx-auto mt-5 mb-3 px-8 py-1 rounded-md w-[11.875rem] h-8"
                })
            ]
        })
    });
};

});
parcelRegister("bGu79", function(module, exports) {

$parcel$export(module.exports, "EstateSelectorFallback", function () { return $27ecb7bec8d01a47$export$c54c06577835e812; });

var $a9eYm = parcelRequire("a9eYm");
const $27ecb7bec8d01a47$export$c54c06577835e812 = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "w-[5.625rem] h-[5.625rem] justify-self-center select-none lg:h-[5.8125rem]",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: "bg-grey50 p-3 rounded-md w-[5.625rem] h-[5.625rem] animate-pulse"
        })
    });
};

});


parcelRegister("67EyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23722fec40a37891$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $23722fec40a37891$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $dTCkE.useState)();
    (0, $dTCkE.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>setMatches(media.matches);
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        query,
        matches
    ]);
    return matches;
};
var $23722fec40a37891$export$2e2bcd8739ae039 = $23722fec40a37891$var$useMediaQuery;

});

parcelRegister("1QzIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f730acaadd400cc$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $lkmZP = parcelRequire("lkmZP");

var $cUbQm = parcelRequire("cUbQm");

var $4VgqT = parcelRequire("4VgqT");

var $l8eky = parcelRequire("l8eky");

var $dNouV = parcelRequire("dNouV");

var $lfpe5 = parcelRequire("lfpe5");

var $dEQYx = parcelRequire("dEQYx");

var $22cn8 = parcelRequire("22cn8");

var $c0xNe = parcelRequire("c0xNe");

var $5J7FU = parcelRequire("5J7FU");

var $8IDY3 = parcelRequire("8IDY3");

const $9f730acaadd400cc$var$EstateCardContent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("jLyND")));
const $9f730acaadd400cc$var$SearchField = ({ inputLabel: inputLabel, activeInput: activeInput, countySelected: countySelected, multipleEstateTypesSelected: multipleEstateTypesSelected, brokerOrOfficeTypesSelected: brokerOrOfficeTypesSelected, commercialOrProject: commercialOrProject, stickyField: stickyField = false, showMapFilter: showMapFilter })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [searchTerm, setSearchTerm] = (0, $dTCkE.useState)("");
    const [inputValue, setInputValue] = (0, $dTCkE.useState)("");
    const debouncedSearchTerm = (0, $l8eky.useDebounce)(searchTerm, 200);
    const [acResults, setACResults] = (0, $dTCkE.useState)();
    const [showSearchResults, setShowSearchResults] = (0, $dTCkE.useState)(false);
    const [showNoSearchResults, setShowNoSearchResults] = (0, $dTCkE.useState)(false);
    const [freetext, setFreetext] = (0, $dTCkE.useState)("");
    const ref = (0, $dTCkE.useRef)(null);
    const [hideAC, setHideAc] = (0, $dTCkE.useState)(false);
    const { data: resp } = (0, $8IDY3.default)(freetext);
    (0, $l8eky.useOnClickOutside)(ref, ()=>setHideAc(true));
    const escPressed = (0, $l8eky.useKeyPress)("Escape");
    (0, $dTCkE.useEffect)(()=>{
        document.addEventListener("keydown", (0, $l8eky.handleUpAndDown));
        return ()=>{
            document.removeEventListener("keydown", (0, $l8eky.handleUpAndDown));
        };
    }, []);
    (0, $dTCkE.useEffect)(()=>{
        setACResults(resp);
    }, [
        resp
    ]);
    (0, $dTCkE.useEffect)(()=>{
        const query = debouncedSearchTerm.trim();
        if (!query || query.length < 2) setACResults(null);
        else {
            setFreetext(query);
            setHideAc(false);
        }
    }, [
        debouncedSearchTerm
    ]);
    function updateLocationTags(type, label, id, county, municipality) {
        const tagsWithPolygonsRemoved = filterContext.tags.filter((x)=>![
                "polygons"
            ].includes(x.type));
        const existingTag = tagsWithPolygonsRemoved.some((x)=>x.label === label);
        if (existingTag) filterContext.setTags(tagsWithPolygonsRemoved.filter((x)=>x.label !== label));
        else filterContext.setTags([
            ...tagsWithPolygonsRemoved,
            {
                type: type,
                label: label,
                id: id,
                county: county,
                municipality: municipality
            }
        ]);
    }
    function updateEstateTypeTags(estateType) {
        const existingFarmTag = filterContext.tags.filter((x)=>x.estateType === (0, $cUbQm.EstateType).Agriculture && x.type === (0, $cUbQm.FilterTypes).EstateType);
        if (existingFarmTag && estateType === (0, $cUbQm.EstateType).Agriculture) {
            const filteredArray = filterContext.tags.filter((x)=>x.type !== (0, $cUbQm.FilterTypes).Alignment && x.estateType !== estateType);
            filterContext.setTags(filteredArray);
        } else {
            const existingTag = filterContext.tags.some((x)=>x.estateType === estateType && x.type === (0, $cUbQm.FilterTypes).EstateType);
            if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>x.estateType !== estateType));
            else filterContext.setTags([
                ...filterContext.tags,
                {
                    type: (0, $cUbQm.FilterTypes).EstateType,
                    estateType: estateType
                }
            ]);
        }
    }
    function updateRangeTags(type, minVal, maxVal, name) {
        const existingTag = filterContext.tags.some((x)=>x.name === name && x.type === type);
        if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>x.name !== name));
        else filterContext.setTags([
            ...filterContext.tags,
            {
                name: name,
                minVal: minVal,
                maxVal: maxVal,
                type: type
            }
        ]);
    }
    function updateExtraCritTags(type, id, text) {
        const existingTag = filterContext.tags.some((x)=>x.id === id && x.text === text && x.type === type);
        if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>x.id !== id));
        else filterContext.setTags([
            ...filterContext.tags,
            {
                type: (0, $cUbQm.FilterTypes).ExtraCritera,
                id: id,
                text: text
            }
        ]);
    }
    function updatePolygonsTag(type) {
        const existingTag = filterContext.tags.some((x)=>x.type === type);
        if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>x.type !== type));
    }
    function updateAlignmentTags(id) {
        const existingTag = filterContext.tags.some((x)=>x.id === id);
        if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>x.id !== id));
        else filterContext.setTags([
            ...filterContext.tags,
            {
                type: (0, $cUbQm.FilterTypes).Alignment,
                id: id
            }
        ]);
    }
    function updateFromKeyPress(event) {
        function updateFromAcResults() {
            if (!!acResults?.municipalities[0]) {
                updateLocationTags((0, $cUbQm.FilterTypes).Municipality, `${acResults?.municipalities[0].name} (Kommun)`, acResults?.municipalities[0].name);
                setInputValue("");
                setSearchTerm("");
            } else if (!!acResults?.areas[0]) {
                updateLocationTags((0, $cUbQm.FilterTypes).Area, `${acResults?.areas[0].name} (${acResults?.areas[0].municipality} kommun)`, acResults?.areas[0].id);
                setInputValue("");
                setSearchTerm("");
            } else if (!!acResults?.counties[0]) {
                updateLocationTags((0, $cUbQm.FilterTypes).County, `${acResults?.counties[0].name} (L\xe4n)`, acResults?.counties[0].name);
                setInputValue("");
                setSearchTerm("");
            }
            return;
        }
        if (document !== null) {
            if (event.key === "Enter") updateFromAcResults();
        }
    }
    function updateFromKeyDown(event, currentInputValue) {
        if (filterContext.tags.length > 0) {
            const listFreeFromShowOnly = filterContext.tags.filter((x)=>x.type !== (0, $cUbQm.FilterTypes).ShowOnlyHeadStart && x.type !== (0, $cUbQm.FilterTypes).ShowSold);
            if (listFreeFromShowOnly.length > 0) {
                let itemToCheckForRemove = filterContext.tags[filterContext.tags.length - 1];
                if (event.key === "Backspace" && currentInputValue === "") {
                    if (itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).ShowSold || itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).ShowOnlyHeadStart) {
                        if (filterContext.tags.length > 1) {
                            itemToCheckForRemove = filterContext.tags[filterContext.tags.length - 2];
                            if (itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).ShowSold || itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).ShowOnlyHeadStart) {
                                if (filterContext.tags.length > 2) itemToCheckForRemove = filterContext.tags[filterContext.tags.length - 3];
                            }
                        }
                    }
                    if (itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).EstateType) filterContext.setTags(filterContext.tags.filter((x)=>x.estateType !== itemToCheckForRemove.estateType));
                    else if (itemToCheckForRemove.type === (0, $cUbQm.FilterTypes).RangeTag) filterContext.setTags(filterContext.tags.filter((x)=>x.name !== itemToCheckForRemove.name));
                    else filterContext.setTags(filterContext.tags.filter((x)=>x.id !== itemToCheckForRemove.id));
                }
            }
        }
    }
    function updateStatusTags(type) {
        const existingStatusTag = filterContext.tags.some((x)=>x.type === type);
        if (existingStatusTag) filterContext.setTags(filterContext.tags.filter((x)=>x.type !== type));
        else filterContext.setTags([
            ...filterContext.tags,
            {
                type: type,
                isChecked: false
            }
        ]);
    }
    (0, $dTCkE.useEffect)(()=>{
        if (escPressed) setHideAc(true);
    }, [
        escPressed
    ]);
    (0, $dTCkE.useEffect)(()=>{
        setShowSearchResults((0, $c0xNe.shouldShowSearchResults)(hideAC, acResults));
        setShowNoSearchResults((0, $c0xNe.shouldShowNoSearchResults)(hideAC, acResults));
    }, [
        hideAC,
        acResults
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (stickyField) {
            const el = document.querySelector(".sticky-field");
            if (el) {
                const observer = new IntersectionObserver(([e])=>{
                    const shouldAddClasses = e.intersectionRatio < 1;
                    e.target.classList.toggle("shadow-bs60", shouldAddClasses);
                    if (shouldAddClasses && !showMapFilter) e.target.classList.add("pt-14");
                    else e.target.classList.remove("pt-14");
                    e.target.classList.toggle("isSticky", shouldAddClasses);
                }, {
                    threshold: [
                        1
                    ]
                });
                observer.observe(el);
                return ()=>observer.disconnect();
            }
        }
    }, [
        stickyField,
        showMapFilter
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: `bg-white ${stickyField ? "sticky lg:static top-[-1px] left-0 z-[11] py-2 sticky-field" : ""}`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "z-[10] flex flex-wrap bg-grey50 mr-3 pl-2 border-white rounded-r-3xl",
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "flex flex-wrap flex-grow py-2 w-auto search-field",
                    children: [
                        filterContext?.tags && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: "flex flex-wrap gap-2 mr-2",
                            children: [
                                filterContext.tags.map((x, i)=>{
                                    if (!activeInput && (x.type === (0, $cUbQm.FilterTypes).County || x.type === (0, $cUbQm.FilterTypes).Municipality || x.type === (0, $cUbQm.FilterTypes).Area)) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        onClick: ()=>{
                                            updateLocationTags(x.type, x.label, x.id, x.county, x.municipality);
                                        }
                                    }, i);
                                    else if (activeInput && countySelected && x.type === (0, $cUbQm.FilterTypes).County) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        onClick: ()=>{
                                            updateLocationTags(x.type, x.label, x.id, x.county, x.municipality);
                                        }
                                    }, i);
                                    else if (activeInput && (x.type === (0, $cUbQm.FilterTypes).Municipality || x.type === (0, $cUbQm.FilterTypes).Area)) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        onClick: ()=>{
                                            updateLocationTags(x.type, x.label, x.id, x.county, x.municipality);
                                        }
                                    }, i);
                                    else if (!activeInput && x.type === (0, $cUbQm.FilterTypes).EstateType) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.estateType,
                                        onClick: ()=>{
                                            updateEstateTypeTags(x.estateType);
                                        }
                                    }, i);
                                    else if (activeInput && x.type === (0, $cUbQm.FilterTypes).EstateType) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.estateType,
                                        warningMsg: multipleEstateTypesSelected,
                                        errorMsg: commercialOrProject,
                                        onClick: ()=>{
                                            updateEstateTypeTags(x.estateType);
                                        }
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).RangeTag) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        onClick: ()=>{
                                            updateRangeTags(x.type, 0, 0, x.name);
                                        },
                                        children: x.name === "Pris" && x.minVal !== undefined && x.maxVal !== undefined ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                x.name,
                                                ": ",
                                                (0, $l8eky.formatLargeNumbers)(x.minVal),
                                                "-",
                                                (0, $l8eky.formatLargeNumbers)(x.maxVal),
                                                x.maxVal === 15000000 ? "+" : "",
                                                " SEK"
                                            ]
                                        }) : x.name === "Avgift" && x.minVal !== undefined && x.maxVal !== undefined ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                x.name,
                                                ": ",
                                                (0, $l8eky.formatLargeNumbers)(x.minVal),
                                                "-",
                                                (0, $l8eky.formatLargeNumbers)(x.maxVal),
                                                x.maxVal === 10000 ? "+" : "",
                                                " SEK"
                                            ]
                                        }) : x.name === "Boarea" ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                x.name,
                                                ": ",
                                                x.minVal,
                                                "-",
                                                x.maxVal,
                                                x.maxVal === 200 ? "+" : "",
                                                " m\xb2"
                                            ]
                                        }) : x.name === "Tomtarea" && x.minVal !== undefined && x.maxVal !== undefined ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                x.name,
                                                ": ",
                                                (0, $l8eky.formatLargeNumbers)(x.minVal),
                                                "-",
                                                (0, $l8eky.formatLargeNumbers)(x.maxVal),
                                                x.maxVal === 15000 ? "+" : "",
                                                " m\xb2"
                                            ]
                                        }) : /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                x.name,
                                                ": ",
                                                x.minVal,
                                                "-",
                                                x.maxVal,
                                                x.maxVal === 10 ? "+" : ""
                                            ]
                                        })
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).ExtraCritera) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.text,
                                        onClick: ()=>{
                                            updateExtraCritTags("extraCriteria", x.id, x.text);
                                        }
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).Alignment) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.id,
                                        onClick: ()=>{
                                            updateAlignmentTags(x.id);
                                        }
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).Broker || x.type === (0, $cUbQm.FilterTypes).Office) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        errorMsg: brokerOrOfficeTypesSelected,
                                        onClick: ()=>{
                                            updateStatusTags(x.type);
                                        },
                                        children: Object.keys(x.label).map((key)=>x.label[key])
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).ShowGreenEstates && x.isChecked) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        errorMsg: brokerOrOfficeTypesSelected,
                                        onClick: ()=>{
                                            updateStatusTags(x.type);
                                        },
                                        children: x.label
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).ShowBidding && x.isChecked) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        errorMsg: brokerOrOfficeTypesSelected,
                                        onClick: ()=>{
                                            updateStatusTags(x.type);
                                        },
                                        children: x.label
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).ShowOnlyHeadStart && x.isChecked) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        errorMsg: brokerOrOfficeTypesSelected,
                                        onClick: ()=>{
                                            updateStatusTags(x.type);
                                        },
                                        children: (0, $cUbQm.Status).headStartPlural
                                    }, i);
                                    else if (x.type === (0, $cUbQm.FilterTypes).ShowSold && x.isChecked) return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        onClick: ()=>{
                                            updateStatusTags(x.type);
                                        },
                                        children: (0, $cUbQm.Status).sold
                                    }, i);
                                    else if (x.type === "polygons") return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lfpe5.default), {
                                        index: i,
                                        text: x.label,
                                        onClick: ()=>{
                                            updatePolygonsTag(x.type);
                                        }
                                    }, i);
                                    else return null;
                                }),
                                activeInput && (filterContext.tags.length === 0 || filterContext.tags.filter((x)=>x.type === "showSold" || x.type === "showOnlyHeadStart" || x.type === "sortType").length > 0 && filterContext.tags.filter((x)=>x.type !== "showSold" && x.type !== "showOnlyHeadStart" && x.type !== "sortType").length === 0) && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    className: "mt-2 text-grey300",
                                    children: "F\xf6r att skapa en bevakning m\xe5ste du ha valt n\xe5gra s\xf6kparametrar."
                                })
                            ]
                        }),
                        !activeInput && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            id: "searchfield-input-wrapper",
                            className: "relative flex flex-grow py-0 mdplus:py-2 pr-6",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                                    "aria-label": (0, $cUbQm.Estates).SearchPlaceholder,
                                    name: "searchfield-input",
                                    id: "searchfield-input",
                                    className: "bg-transparent py-2 lg:py-1 focus:outline-none w-full text-black500 md:text-base",
                                    type: "search",
                                    value: inputValue,
                                    placeholder: inputLabel,
                                    autoComplete: "off",
                                    onClick: ()=>setHideAc(false),
                                    onChange: (e)=>{
                                        setSearchTerm(e.currentTarget.value);
                                        setInputValue(e.currentTarget.value);
                                    },
                                    disabled: activeInput,
                                    onKeyPress: updateFromKeyPress,
                                    onKeyDown: (e)=>{
                                        updateFromKeyDown(e, inputValue);
                                    }
                                }),
                                filterContext.tags.filter((x)=>x.type !== "sortType" && x.type !== (0, $cUbQm.FilterTypes).AllEstates).length > 0 ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dNouV.RemoveFiltersButton), {
                                    resetTags: ()=>{
                                        filterContext.setTags([
                                            {
                                                type: (0, $cUbQm.FilterTypes).AllEstates,
                                                isChecked: true,
                                                label: "Alla bost\xe4der"
                                            }
                                        ]);
                                    }
                                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dEQYx.default), {})
                            ]
                        })
                    ]
                })
            }),
            showSearchResults && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative",
                ref: ref,
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    id: "ac-result-list",
                    className: "left-0 z-50 absolute bg-white shadow-bs80 mt-2 border-t-grey100 w-[calc(100%-0.75rem)] max-h-xl overflow-hidden overflow-y-auto",
                    children: [
                        !!acResults?.municipalities.length && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "outline-none",
                            children: acResults.municipalities?.map((x, i)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $lkmZP.TagSelectButton), {
                                    classToChild: i === 0 ? `bg-grey50` : "",
                                    onClick: ()=>{
                                        updateLocationTags("munici", `${x.name} (Kommun)`, x.name);
                                        setHideAc(true);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    },
                                    text: x.name,
                                    type: "Kommun",
                                    handleKeyPress: ()=>{
                                        updateLocationTags("munici", `${x.name} (Kommun)`, x.name);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    }
                                }, x.name))
                        }),
                        !!acResults?.areas.length && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "outline-none",
                            children: acResults.areas?.map((x, i)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $lkmZP.TagSelectButton), {
                                    classToChild: i === 0 && !acResults.municipalities.length ? `bg-grey50` : "",
                                    onClick: ()=>{
                                        updateLocationTags("area", `${x.name} (${x.municipality} kommun)`, x.id);
                                        setHideAc(true);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    },
                                    text: x.name,
                                    type: `${x.municipality} kommun`,
                                    handleKeyPress: ()=>{
                                        updateLocationTags("area", `${x.name} (${x.municipality} kommun)`, x.id);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    }
                                }, x.id))
                        }),
                        !!acResults?.counties.length && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "outline-none",
                            children: acResults.counties?.map((x, i)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $lkmZP.TagSelectButton), {
                                    classToChild: i === 0 && acResults.municipalities.length === 0 && acResults.areas.length === 0 ? `bg-grey50` : "",
                                    onClick: ()=>{
                                        updateLocationTags("county", `${x.name} (L\xe4n)`, x.name);
                                        setHideAc(true);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    },
                                    text: x.name,
                                    type: "L\xe4n",
                                    handleKeyPress: ()=>{
                                        updateLocationTags("county", `${x.name} (L\xe4n)`, x.name);
                                        setInputValue("");
                                        setSearchTerm("");
                                        (0, $l8eky.focusOnInput)();
                                    }
                                }, x.name))
                        }),
                        !!acResults?.estates.length && /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("h3", {
                                    className: "my-3 ml-3",
                                    children: (0, $5J7FU.ForSaleStrings).Estates
                                }),
                                acResults.estates?.map((x)=>x.estateType !== (0, $cUbQm.EstateType).Commercial && x.status !== (0, $cUbQm.EstateStatuses).Sold && /*#__PURE__*/ (0, $a9eYm.jsx)("a", {
                                        className: "block hover:bg-grey50 px-3 py-3 border-grey75 border-b outline-none acResult",
                                        href: x.url,
                                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                    className: "rounded-md max-w-1/4 h-20 md:h-[6rem] overflow-hidden",
                                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                        src: x.headerImage ? x.headerImage : "/Images/fallbacks/hero-image-fallback.jpg",
                                                        className: "w-full h-full object-cover",
                                                        alt: `${x.streetAddress}`,
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                    className: "flex-grow -mx-0 md:mx-0 -my-6 md:-my-4 min-w-1/4",
                                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($9f730acaadd400cc$var$EstateCardContent, {
                                                            estate: x
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, x.url))
                            ]
                        })
                    ]
                })
            }),
            showNoSearchResults && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $4VgqT.default), {
                    searchTerm: searchTerm
                })
            })
        ]
    });
};
var $9f730acaadd400cc$export$2e2bcd8739ae039 = $9f730acaadd400cc$var$SearchField;

});
parcelRegister("lkmZP", function(module, exports) {

$parcel$export(module.exports, "TagSelectButton", function () { return $ae60f4327886f8c3$export$f6030b00520bd4d4; });

var $a9eYm = parcelRequire("a9eYm");
const $ae60f4327886f8c3$export$f6030b00520bd4d4 = ({ text: text, type: type, onClick: onClick, handleKeyPress: handleKeyPress, classToChild: classToChild })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        onClick: onClick,
        className: `${classToChild} hover:bg-blue100 p-4 cursor-pointer border-b border-grey75 flex justify-between outline-none focus:bg-blue100`,
        tabIndex: 0,
        onKeyPress: handleKeyPress,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                children: [
                    text,
                    " (",
                    type,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "text-sm font-icb",
                children: type !== "L\xe4n" && type !== "Kommun" ? "OMR\xc5DE" : type.toLocaleUpperCase()
            })
        ]
    });
};

});

parcelRegister("dNouV", function(module, exports) {

$parcel$export(module.exports, "RemoveFiltersButton", function () { return $8fafa9a27398bc11$export$a4c8ca1b6343dfe9; });

var $a9eYm = parcelRequire("a9eYm");
const $8fafa9a27398bc11$export$a4c8ca1b6343dfe9 = ({ resetTags: resetTags })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
        "aria-label": "Rensa filter",
        title: "Ta bort alla filter",
        className: "top-1/2 right-2 absolute self-center bg-grey50 p-2 rounded-full focus:outline-none translate-y-1/2- button",
        type: "button",
        onClick: ()=>{
            resetTags();
        },
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
            src: "/Images/Icons/close.svg",
            alt: "Ta bort filter ikon",
            width: 21,
            height: 21,
            loading: "lazy"
        })
    });
};

});

parcelRegister("lfpe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $955ee5977b40e142$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $jseYg = parcelRequire("jseYg");
const $955ee5977b40e142$var$RemoveFilterBtn = ({ children: children, index: index, text: text, onClick: onClick, errorMsg: errorMsg, warningMsg: warningMsg })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
        type: "button",
        className: "self-center filter-btn focus:outline-none font-ic cursor-pointer",
        title: "Ta bort filter: " + text,
        tabIndex: 0,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
            className: `flex rounded-full py-1 px-3 md:py-2 ${errorMsg ? "bg-red100 hover:shadow-bs40 text-blue1000" : warningMsg ? "bg-yellow700 hover:shadow-bs40 text-white" : "bg-blue700 hover:bg-blue900 text-white"}`,
            children: [
                children ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
                    children: children
                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
                    children: text
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $jseYg.default), {
                    error: errorMsg,
                    onClick: onClick
                })
            ]
        })
    }, index);
};
var $955ee5977b40e142$export$2e2bcd8739ae039 = $955ee5977b40e142$var$RemoveFilterBtn;

});
parcelRegister("jseYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81881f49c45b8c39$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $81881f49c45b8c39$var$RemoveFilterImg = ({ onClick: onClick, error: error })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
        className: "self-center ml-3 h-2 `w-2",
        src: error ? "/Images/Icons/close-blue1000.svg" : "/Images/Icons/close-white.svg",
        alt: "Ikon kryss ta bort filter",
        width: 12,
        height: 12,
        onClick: onClick
    });
};
var $81881f49c45b8c39$export$2e2bcd8739ae039 = $81881f49c45b8c39$var$RemoveFilterImg;

});


parcelRegister("dEQYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e437ca0a10d5905f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $e437ca0a10d5905f$var$SearchFieldBtn = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `search-field-btn bg-blue700 p-2 rounded-full self-center button focus:outline-none w-10 h-10 flex justify-center items-center absolute top-1/2 translate-y-1/2- 
       right-2
      `,
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
            className: "w-4 h-4",
            src: "/Images/Icons/search-icon.svg",
            alt: "S\xf6k ikon",
            width: 16,
            height: 16,
            loading: "lazy"
        })
    });
};
var $e437ca0a10d5905f$export$2e2bcd8739ae039 = $e437ca0a10d5905f$var$SearchFieldBtn;

});

parcelRegister("5J7FU", function(module, exports) {

$parcel$export(module.exports, "ForSaleStrings", function () { return $99df1cd5eac2d33b$export$bcfdb61b9eaf9a50; });
var $99df1cd5eac2d33b$export$bcfdb61b9eaf9a50;
(function(ForSaleStrings) {
    ForSaleStrings["NotFindingHeadling"] = "Hittar du inte vad du s\xf6ker?";
    ForSaleStrings["NotFindingText"] = "Oroa dig inte. Vi f\xe5r in nya bost\xe4der hela tiden. Kanske \xe4r din dr\xf6mbostad bara ett par dagar bort? Skapa en bevakning s\xe5 att du inte missar n\xe4r den dyker upp!";
    ForSaleStrings["FetchError"] = "Kunde inte h\xe4mta bost\xe4der just nu. F\xf6rs\xf6k igen om en liten stund.";
    ForSaleStrings["Estates"] = "Bost\xe4der";
    ForSaleStrings["SingleEstate"] = "Bostad";
    ForSaleStrings["NoResults"] = "Din s\xf6kning gav inga tr\xe4ffar";
    ForSaleStrings["Loading"] = "Laddar...";
    ForSaleStrings["Bidding"] = "Budgivning p\xe5g\xe5r";
    ForSaleStrings["BiddingShort"] = "Budgivning";
})($99df1cd5eac2d33b$export$bcfdb61b9eaf9a50 || ($99df1cd5eac2d33b$export$bcfdb61b9eaf9a50 = {}));

});

parcelRegister("8IDY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39fd1f118f25a738$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $39fd1f118f25a738$var$useAutocomplete = (freetext)=>{
    return (0, $4cyLg.useQuery)([
        "freetext",
        freetext
    ], ()=>(0, $1HGFx.SearchService).searchAutoComplete(freetext).then((response)=>response), {
        enabled: !!freetext,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $39fd1f118f25a738$export$2e2bcd8739ae039 = $39fd1f118f25a738$var$useAutocomplete;

});

parcelRegister("jLyND", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cCZ7C")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd"))
]).then(()=>parcelRequire("3q65I"));

});


parcelRegister("lcDRl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $04e99f6d1e4cad74$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $cUbQm = parcelRequire("cUbQm");

var $a1uyt = parcelRequire("a1uyt");
const $04e99f6d1e4cad74$var$CreateSearchProfileBtn = ({ setShowHideModalFunction: setShowHideModalFunction, isScrollOverHeadline: isScrollOverHeadline = false, sessionId: sessionId })=>{
    const { isAuthorizedBroker: isAuthorizedBroker, setShowErrorForSale: setShowErrorForSale } = (0, $dTCkE.useContext)((0, $a1uyt.ForSaleBrokerContext));
    const [bottomPos, setBottomPos] = (0, $dTCkE.useState)("bottom-[-4rem]");
    (0, $dTCkE.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollPosition = window.scrollY || window.pageYOffset;
            if (window.innerWidth < 1024 && scrollPosition > 450) {
                if (bottomPos != "bottom-4") setBottomPos("bottom-4");
                else setBottomPos("bottom-[-4rem]");
            } else setBottomPos("bottom-[-4rem]");
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `${isScrollOverHeadline ? "xxl:bottom-6" : "xxl:bottom-8"} ${bottomPos} mdplus:bottom-4 lg:sticky fixed left-0 z-[998] w-full lg:w-1/4 lg:min-w-[25.8rem] transition-all duration-75`,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
            className: "px-8 py-3 text-center rounded-3xl bg-blue700/70 lg:bg-blue700/80 hover:bg-blue700 transition-all duration-200 text-white mx-auto hover:cursor-pointer focus:outline-none button flex items-center",
            type: "button",
            onClick: ()=>{
                isAuthorizedBroker && sessionId != null ? setShowErrorForSale(true) : setShowHideModalFunction(true);
            },
            children: [
                (0, $cUbQm.Estates).CreateSearchProfile,
                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                    width: 24,
                    height: 24,
                    className: "w-6 ml-2",
                    src: "/Images/Icons/monitoring_white.svg",
                    alt: "Ikon skapa bevakning"
                })
            ]
        })
    });
};
var $04e99f6d1e4cad74$export$2e2bcd8739ae039 = $04e99f6d1e4cad74$var$CreateSearchProfileBtn;

});

parcelRegister("i7TBI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c5f8c40173f1fa5$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $9c5f8c40173f1fa5$var$useSiteHeaderHeight = ()=>{
    const [menuHeight, setMenuHeight] = (0, $dTCkE.useState)(0);
    (0, $dTCkE.useEffect)(()=>{
        const siteHeader = document.querySelector(".site-header");
        if (!siteHeader) return;
        const observer = new ResizeObserver(()=>{
            setMenuHeight(siteHeader.offsetHeight);
        });
        observer.observe(siteHeader);
        return ()=>observer.disconnect();
    }, []);
    return menuHeight;
};
var $9c5f8c40173f1fa5$export$2e2bcd8739ae039 = $9c5f8c40173f1fa5$var$useSiteHeaderHeight;

});

parcelRegister("34thG", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("eyd9t")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jedBR"))
]).then(()=>parcelRequire("lmTo9"));

});

parcelRegister("2wZwx", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("gOafK")).then(()=>parcelRequire("fPMhU"));

});

parcelRegister("iYbNK", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cCZ7C")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cWuXQ"))
]).then(()=>parcelRequire("ccRjs"));

});

parcelRegister("cCGyt", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("5iq3S")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("fxy8V")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iDs0B"))
]).then(()=>parcelRequire("hSBVu"));

});



parcelRegister("515ZP", function(module, exports) {

$parcel$export(module.exports, "apiUrl", function () { return $faac5a7a58925656$export$e9ddf1da8d18d6f; });
$parcel$export(module.exports, "kycPortalUrl", function () { return $faac5a7a58925656$export$ad8fbf1335de6218; });
$parcel$export(module.exports, "getBrokerName", function () { return $faac5a7a58925656$export$8e6d207ebd320889; });
$parcel$export(module.exports, "getOfficeName", function () { return $faac5a7a58925656$export$e7fc2f87021c4f26; });
$parcel$export(module.exports, "getPersonalData", function () { return $faac5a7a58925656$export$35cd3e25af2ef930; });
$parcel$export(module.exports, "getMunicipalityTag", function () { return $faac5a7a58925656$export$930ee366b3d03280; });
$parcel$export(module.exports, "getCountyTag", function () { return $faac5a7a58925656$export$cebb9be7766a1779; });
$parcel$export(module.exports, "getQuestionListData", function () { return $faac5a7a58925656$export$f953ee8ad3c2f078; });
$parcel$export(module.exports, "getGeneralInfoData", function () { return $faac5a7a58925656$export$cfa44af66bbf621d; });
$parcel$export(module.exports, "getEconomyInfoData", function () { return $faac5a7a58925656$export$1c959a0887934c9; });
$parcel$export(module.exports, "getAboutEstateInfoData", function () { return $faac5a7a58925656$export$b4f8909e2e1b029f; });
$parcel$export(module.exports, "getHomeAssignmentDates", function () { return $faac5a7a58925656$export$c2f02f2cdcb26bb4; });
$parcel$export(module.exports, "getSurroundingInfoData", function () { return $faac5a7a58925656$export$c5edcf354e7951a6; });
$parcel$export(module.exports, "getTechnicalInfoData", function () { return $faac5a7a58925656$export$41378c6a48631b14; });
$parcel$export(module.exports, "getDeclarationBasisDates", function () { return $faac5a7a58925656$export$23160db3718428b9; });
$parcel$export(module.exports, "getDeclarationBasisSettlement", function () { return $faac5a7a58925656$export$5b598e839c07c5f4; });
$parcel$export(module.exports, "getDeclarationBasisSale", function () { return $faac5a7a58925656$export$e05d5ef9aa09290e; });
$parcel$export(module.exports, "getDeclarationBasisPurchase", function () { return $faac5a7a58925656$export$c7312eab72c6dcef; });
$parcel$export(module.exports, "getDeclarationBasisSuspension", function () { return $faac5a7a58925656$export$f9dd191eee96b121; });
$parcel$export(module.exports, "getDeclarationBasisMAR", function () { return $faac5a7a58925656$export$4905b08d33ae334f; });
$parcel$export(module.exports, "getToDoDates", function () { return $faac5a7a58925656$export$8da75b13c89971e6; });
$parcel$export(module.exports, "getKycForm", function () { return $faac5a7a58925656$export$ac86386cf209f951; });
$parcel$export(module.exports, "getWebsiteVisitor", function () { return $faac5a7a58925656$export$1f48879c04f44a0f; });
$parcel$export(module.exports, "getMunicipalityData", function () { return $faac5a7a58925656$export$9593ca3a476838b5; });
$parcel$export(module.exports, "getObjectTypeData", function () { return $faac5a7a58925656$export$64e4b188c77435e6; });
$parcel$export(module.exports, "getLoginInfo", function () { return $faac5a7a58925656$export$ebe451eb84baa5b8; });
$parcel$export(module.exports, "getGepositData", function () { return $faac5a7a58925656$export$cc20294e6e95aa8; });
$parcel$export(module.exports, "getNrOfSpeculators", function () { return $faac5a7a58925656$export$1c33aa1c52378f0; });
const $faac5a7a58925656$export$40edfb7eeb78c4e8 = true;
const $faac5a7a58925656$export$e9ddf1da8d18d6f = "https://app-lansfast-api.azurewebsites.net";
const $faac5a7a58925656$export$ad8fbf1335de6218 = "https://kyc.lansfast.se";
const $faac5a7a58925656$export$ad2637a4162a5855 = "http://localhost:5208";
const $faac5a7a58925656$export$90b486e772451dd = window.location.origin;
const $faac5a7a58925656$export$a1449de16bf292a7 = "/umbraco/api";
const $faac5a7a58925656$export$8e6d207ebd320889 = async (brokerId)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/GetBrokerTag?brokerId=${brokerId}`);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$e7fc2f87021c4f26 = async (customerId)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/GetOfficeTag?customerId=${customerId}`);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$35cd3e25af2ef930 = async (ssn)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/persondata/getpersoninformation?SSN=${ssn}`);
    const personalData = await response.json();
    return personalData;
};
const $faac5a7a58925656$export$930ee366b3d03280 = async (municipality)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/CreateMunicipalityTags?municipality=${municipality}`);
    const data = await response.json();
    return data?.tag;
};
const $faac5a7a58925656$export$cebb9be7766a1779 = async (county)=>{
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + `/api/Search/CreateCountyTags?county=${county}`);
    const data = await response.json();
    return data?.tag;
};
const $faac5a7a58925656$export$f953ee8ad3c2f078 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/GetQuestionList?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$cfa44af66bbf621d = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetGeneralInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$1c959a0887934c9 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetEconomyInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$b4f8909e2e1b029f = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetAboutEstateInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c2f02f2cdcb26bb4 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c5edcf354e7951a6 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetSurroundingInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$41378c6a48631b14 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/HomeAssignment/GetTechnicalInfo?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$23160db3718428b9 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$5b598e839c07c5f4 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSettlement?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$e05d5ef9aa09290e = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSale?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$c7312eab72c6dcef = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetPurchase?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$f9dd191eee96b121 = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetSuspension?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$4905b08d33ae334f = async (sessionId, estateId)=>{
    const GET_URL = `/api/MyPages/DeclarationBasis/GetMaintenanceAndRebuilding?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$8da75b13c89971e6 = async (sessionId, estateId)=>{
    const SAVE_URL = `/api/MyPages/GetToDoDates?` + new URLSearchParams({
        sessionId: sessionId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + SAVE_URL);
    const data = await response.json();
    return data;
};
const $faac5a7a58925656$export$ac86386cf209f951 = async (userId, estateId)=>{
    const GET_URL = `/api/User/GetKycForms?` + new URLSearchParams({
        sessionId: userId,
        estateId: estateId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const data = await response.json();
    return data || null;
};
const $faac5a7a58925656$export$1f48879c04f44a0f = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/SourceData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectWebsiteStats = await response.json();
    return objectWebsiteStats;
};
const $faac5a7a58925656$export$9593ca3a476838b5 = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/MunicipalityData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectWebsiteStats = await response.json();
    return objectWebsiteStats;
};
const $faac5a7a58925656$export$64e4b188c77435e6 = async (estateId, sessionId)=>{
    const GET_URL = `/api/Statistics/ObjectTypeData?` + new URLSearchParams({
        estateId: estateId,
        sessionId: sessionId
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const objectData = await response.json();
    return objectData;
};
const $faac5a7a58925656$export$ebe451eb84baa5b8 = async ()=>{
    const GET_URL = "/userapi/login";
    const response = await fetch($faac5a7a58925656$export$90b486e772451dd + $faac5a7a58925656$export$a1449de16bf292a7 + GET_URL);
    const loginInfo = await response.json();
    return loginInfo;
};
const $faac5a7a58925656$export$cc20294e6e95aa8 = async (query)=>{
    const GET_URL = `/api/Forms/GetGepositData?` + new URLSearchParams({
        query: query
    });
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + GET_URL);
    const specResult = await response.json();
    return specResult;
};
const $faac5a7a58925656$export$1c33aa1c52378f0 = async (data)=>{
    const POST_URL = `/api/Forms/SpeculatorCheck`;
    const response = await fetch($faac5a7a58925656$export$e9ddf1da8d18d6f + POST_URL, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    if (response.ok) {
        const specResult = await response.json();
        return specResult;
    } else data.setError("serverError", {
        type: "manual",
        message: response
    });
};

});

})();
//# sourceMappingURL=ForSaleComponent.d128ce06.js.map
